import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CustomizationManager } from '@core/services/customization-manager.service';
import { BillingService } from '@modules/billing/services/billing.service';
import { AssetFetcherService } from '@modules/policy/services/shared/asset-fetcher.service';

@Component({
  selector: 'app-confirmation-step',
  templateUrl: './confirmation-step.component.html',
  styleUrls: ['./confirmation-step.component.scss']
})
export class ConfirmationStepComponent implements OnInit {

  headLine: string;

  constructor(
    private router: Router,
    private customizationManager: CustomizationManager,
    private billingService: BillingService,
    private assetFetcherService: AssetFetcherService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.insertHeadline();
  }

  insertHeadline() {
    this.fetchData().then(headline => {
      this.billingService.boundData.subscribe(data => {
        this.headLine = this.customizationManager.interpolateText(data, headline);
      });
    });
  }

  fetchData(): Promise<string> {
    const { id: policyID } = this.route.snapshot.params;
    return new Promise((resolve) => {
      this.assetFetcherService.getAssetFile({
        name: 'direct-bill-confirmation-message.html',
        quoteId: policyID
      }).subscribe(
        (res) => {
          const headLine = res.data
          resolve(headLine);
        },
        (error) => {
          //fallback
          const headLine = this.customizationManager.get('bind-confirmation');
          resolve(headLine);
        }
      );
    });
  }

  navigateToDashboard() {
    this.router.navigate([`/dashboard`]);
  }
}